'use strict';

import smoothscroll from 'smoothscroll-polyfill';
import svg4everybody from 'svg4everybody/dist/svg4everybody.min.js';

// Polyfill SVG and <use> support
svg4everybody({
  nosvg: false // we provide no fallback support for browsers that don't support SVG at all
});

// Polyfill Array.includes() if necessary
if (!Array.prototype.includes) {
  require('core-js/fn/array/includes');
}

if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  require('promise/lib/rejection-tracking').enable();
  window.Promise = require('promise/lib/es6-extensions.js');
}

// fetch() polyfill for making API calls.
require('whatwg-fetch');

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = require('object-assign');

// Polyfill browser-native smooth scrolling API if necessary
// http://iamdustan.com/smoothscroll/
smoothscroll.polyfill();

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (process.env.NODE_ENV === 'test') {
  require('raf').polyfill(global);
}



//////////////////
// WEBPACK FOOTER
// ../core/config/polyfills.js
// module id = 162
// module chunks = 0